import React from 'react';
import PropTypes from 'prop-types';

const APPLE_LOGIN = {
  CLIENT_ID: 'clarovideo-web-signin',
  DOMAIN: 'https://www.clarovideo.com',
  LOGIN_CALLBACK: '/applesignin',
  ATTACH_CALLBACK: '/loginapplecallback',
  RESPONSE_TYPE: 'code id_token',
  SCOPE: 'name email',
  RESPONSE_MODE: 'form_post',
};

const generateQueryString = q => {
  const queryString = Object.keys(q).reduce((query, key, index)=>{
    return `${query}${index && '&' || '' }${key}=${q[key]}`;
  }, '');

  return queryString;
};

export const redirect = (action = 'login') => {
  const path =
    action === 'login'
      ? APPLE_LOGIN.LOGIN_CALLBACK
      : APPLE_LOGIN.ATTACH_CALLBACK;

  window.location.href = `https://appleid.apple.com/auth/authorize?${generateQueryString(
    {
      response_type: APPLE_LOGIN.RESPONSE_TYPE,
      response_mode: APPLE_LOGIN.RESPONSE_MODE,
      client_id: APPLE_LOGIN.CLIENT_ID,
      redirect_uri: `${APPLE_LOGIN.DOMAIN}${path}`,
      scope: APPLE_LOGIN.SCOPE,
    },
  )}`;
};

const AppleLogin = ({ action, design }) => (
  <div
    role="button"
    onClick={() => redirect(action)}
    className="appleId--button"
    onKeyPress={() => redirect(action)}
    tabIndex={0}
  >
    <img
      src={`https://appleid.cdn-apple.com/appleid/button?${generateQueryString(
        design,
      )}`}
      alt="appleButton"
    />
  </div>
);

AppleLogin.propTypes = {
  action: PropTypes.string,
  design: PropTypes.shape({
    color: PropTypes.string,
    width: PropTypes.number,
    locale: PropTypes.string,
  }),
};

AppleLogin.defaultProps = {
  action: 'login',
  design: {
    color: 'white',
    width: 150,
    locale: 'es_MX',
  },
};

export default AppleLogin;
